module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('img-base64', {
    attrs: {
      "name": 'bind_' + _vm.controllerName
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "font-size-s text-align-center wait-text"
  }, [_vm._v("\n    请去无线局域网将网络切换成您的家庭WiFi " + _vm._s(_vm.wifi) + "\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "font-size-s text-align-center"
  }, [_vm._v(_vm._s(_vm.connectTimeCountDown) + "秒")]), _vm._v(" "), _c('p', {
    staticClass: "font-size-s text-align-center"
  }, [_vm._v(_vm._s(_vm.log))]), _vm._v(" "), _c('div', {
    staticClass: "next-btn"
  }, [_c('button', {
    staticClass: "btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelClick
    }
  }, [_vm._v("取消")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fd12c60"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/connect/wifi/BindController.vue
// module id = 876
// module chunks = 1